import React, { createContext, useContext, useEffect, useState } from "react";
// import { ExternalProvider } from "@metamask/providers";
import { Contract, ethers } from "ethers";

import { useAccount } from "./WalletContext";
import { _WalletGateContract } from "../contracts/WalletGateContract";
import { useGlobal } from "./GlobalContext";
// const message_abi = require("../contracts/WalletGateContract/");

interface MessageNode {
	allMessages: messagesType[];
	setAllMessages: Function;
	getAllMessages: Function;
	getBalance: Function;
	point: string;
	setPoint: Function;
	message: Function;
	deposit: Function;
	withdraw: Function;
	balance: string;
}
const TransactionContext = createContext({} as MessageNode);

interface Props {}
export const TransactionProvider: React.FC<Props> = ({ children }) => {
	const { setIsProcessing } = useGlobal();
	const [allMessages, setAllMessages] = useState<messagesType[]>(
		[] as messagesType[]
	);
	const [balance, setBalance] = useState("");
	const [point, setPoint] = useState("0");

	const { currentAccount } = useAccount();

	const getAllMessages = () => {
		try {
			const WalletGateContract = _WalletGateContract();
			if (WalletGateContract) {
				WalletGateContract.getAllMessages().then((messages: any) => {
					// We only need address, timestamp, and message for our UI
					const messagesCleaned = messages.map((message: any) => {
						return {
							address: message.messager,
							timestamp: new Date(message.timestamp * 1000),
							message: message.message,
						};
					});
					setAllMessages(messagesCleaned);
				});
			} else {
				console.log("Ethereum object doesn't exist!");
			}
		} catch (error) {
			console.log(error);
		}
	};

	const message = async (message: string = "empty message") => {
		try {
			setIsProcessing(true);
			const WalletGateContract = _WalletGateContract();
			if (WalletGateContract) {
				let count = await WalletGateContract.getAllMessages();

				const messageTxn = await WalletGateContract.message(message, {
					gasLimit: 300000, // if transaction costs 250000 the 50,000 will refunded
				});

				// console.log("Mining...", messageTxn.hash);

				await messageTxn.wait();
				// console.log("Mined -- ", messageTxn.hash);

				count = await WalletGateContract.getAllMessages();
				// console.log("Total message : ", count.length);
			} else {
				console.log("Ethereum object doesnt exists");
			}
		} catch (e) {
			console.log(e);
		} finally {
			setIsProcessing(false);
		}
	};

	const getBalance = () => {
		setIsProcessing(true);

		const WalletGateContract = _WalletGateContract();
		try {
			if (WalletGateContract) {
				WalletGateContract.getBalance().then((balance: string) => {
					const balance_number = ethers.utils.formatEther(balance);
					setBalance(balance_number);
				});
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsProcessing(false);
		}
	};

	const getPoints = () => {
		setIsProcessing(true);

		const WalletGateContract = _WalletGateContract();
		try {
			if (WalletGateContract) {
				WalletGateContract.getPoints().then((point: string) => {
					setPoint(ethers.utils.formatEther(point));
				});
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsProcessing(false);
		}
	};

	useEffect(() => {
		const WalletGateContract = _WalletGateContract();

		// let messagePortalContract: Contract;
		getAllMessages();
		getBalance();
		getPoints();

		const onNewMessage = (from: string, timestamp: number, message: string) => {
			// console.log("NewMessage", from, timestamp, message);
			setAllMessages((prevState) => [
				...prevState,
				{
					address: from,
					timestamp: new Date(timestamp * 1000),
					message,
				},
			]);
		};

		if (WalletGateContract) {
			WalletGateContract.on("NewMessage", onNewMessage); // add listener for emitter events
		}
		return () => {
			if (WalletGateContract) {
				WalletGateContract.off("NewMessage", onNewMessage); // remove listener for emitter events
			}
		};
	}, []);

	const deposit = async (value: string) => {
		setIsProcessing(true);

		const WalletGateContract = _WalletGateContract();
		try {
			if (WalletGateContract) {
				const depositTxn = await WalletGateContract.deposit({
					from: currentAccount,
					gasLimit: 300000,
					value: ethers.utils.parseEther(value),
				});

				// console.log("Sending your deposit", depositTxn.hash);
				await depositTxn.wait();
				// console.log("Deposit Success !", depositTxn.hash);
				getBalance();
				getPoints();
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsProcessing(false);
		}
	};

	const withdraw = async (value: string) => {
		setIsProcessing(true);

		const WalletGateContract = _WalletGateContract();
		try {
			if (WalletGateContract) {
				const withdrawTxn = await WalletGateContract.withdraw(
					ethers.utils.parseEther(value)
				);
				// console.log("Sending your withdraw request", withdrawTxn.hash);
				await withdrawTxn.wait();
				// console.log("Withdraw Success !", withdrawTxn.hash);
				getBalance();
				getPoints();
			}
		} catch (e) {
			console.error(e);
		} finally {
			setIsProcessing(false);
		}
	};

	return (
		<TransactionContext.Provider
			value={{
				allMessages,
				setAllMessages,
				getAllMessages,
				getBalance,
				balance,
				point,
				setPoint,
				message,
				deposit,
				withdraw,
			}}
		>
			{children}
		</TransactionContext.Provider>
	);
};

export const useTransaction = () => useContext(TransactionContext);

export type messagesType = {
	address: string;
	timestamp: Date;
	message: string;
};
